import './InsightTimer.css'
function InsightTimer () {
    return (
        <a href="https://insighttimer.com/chloechaput " target="_blank" 
  rel="noopener noreferrer" className="insight-timer">On Demand Meditations</a>
    )
}

export default InsightTimer;